import { Host, h } from '@stencil/core';
export class AibaProgressDots {
  constructor() {
    this.total = undefined;
    this.index = undefined;
    this.handlers = undefined;
  }
  render() {
    return (h(Host, null, h("div", { class: `progress-dots` }, Array.from({ length: this.total }, (_, i) => (h("span", { class: {
        dot: true,
        active: i + 1 === this.index,
      }, key: i }))))));
  }
  static get is() { return "aiba-progress-dots"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-progress-dots.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-progress-dots.css"]
    };
  }
  static get properties() {
    return {
      "total": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total",
        "reflect": false
      },
      "index": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "index",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
}
//# sourceMappingURL=aiba-progress-dots.js.map
